(function(){
  var cfg = window.DanellaV4 = window.DanellaV4 || {};
  var ss = cfg.spendSave = cfg.spendSave || {};
  try {
    if (location.search.indexOf('ss=1') > -1) sessionStorage.setItem('v4ss', '1');
    if (location.search.indexOf('ss=0') > -1) sessionStorage.removeItem('v4ss');
    if (sessionStorage.getItem('v4ss') === '1') ss.enabled = true;
  } catch (e) {}
  cfg.ssOn = function(){ return !!(ss.enabled && ss.tiers && ss.tiers.length); };
  cfg.money = function(c){ var d = c / 100; return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2)); };
  cfg.tierFor = function(cents){ var t = null; (ss.tiers || []).forEach(function(x){ if (cents >= x.min * 100) t = x; }); return t; };
  cfg.nextTier = function(cents){ var n = null; (ss.tiers || []).forEach(function(x){ if (!n && cents < x.min * 100) n = x; }); return n; };
  if (cfg.ssOn()) document.documentElement.classList.add('v4-ss');

  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function(){
    if (cfg.ssOn()) {
      var tr = ss.tiers, lo = tr[0], hi = tr[tr.length - 1];
      var chip = '$' + lo.min + '+ ' + lo.pct + '% · $' + hi.min + '+ ' + hi.pct + '%';
      var wk = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), nd, hits = [];
      while ((nd = wk.nextNode())) { if (nd.nodeValue.indexOf('2 products 5%') > -1) hits.push(nd); }
      hits.forEach(function(x){
        x.nodeValue = chip;
        var a = x.parentElement && x.parentElement.closest('a');
        if (a) a.setAttribute('aria-label', 'Shop single products: ' + lo.pct + '% off at $' + lo.min + ', up to ' + hi.pct + '% off at $' + hi.min);
      });
    }
    var story = document.querySelector('[data-v4-story]');
    var info = document.querySelector('.main-product .product-info__sticky');
    if (story && info) {
      var intro = story.querySelector('[data-v4-intro]');
      var price = info.querySelector('.price');
      if (intro && price) { intro.style.display = 'block'; price.insertAdjacentElement('afterend', intro); }
      var form = info.querySelector('form.product-form, [data-product-form]');
      if (form && cfg.ssOn() && cfg.tierPrices) {
        var tiers = ss.tiers;
        var lad = document.createElement('div');
        lad.className = 'v4-ladder';
        var html = '';
        if (ss.excluded) {
          html = '<p class="v4-ladder__title">Spend more, save more</p><p class="v4-ladder__note">This item is not part of our spend and save savings, so the 10%, 15% and 20% discounts do not apply to it. It still counts toward free U.S. shipping.</p>';
        } else if (cfg.tierPrices) {
          /* Single products: compact box right under Add to bag, with this item's price at each level. */
          lad.className = 'v4-ladder v4-ladder--price';
          html = '<div class="v4-ladder__head"><p class="v4-ladder__title">Spend more, save more</p><p class="v4-ladder__cap">Your price on this item</p></div><div class="v4-ladder__steps">';
          tiers.forEach(function(t){ html += '<div class="v4-ladder__step" data-pct="' + t.pct + '"><b>' + t.pct + '% off</b><span>$' + t.min + '+</span><em class="v4-ladder__price"></em></div>'; });
          html += '</div><p class="v4-ladder__note">Applied automatically in your bag. ' + (ss.note || '') + '</p>';
        } else {
          html = '<p class="v4-ladder__title">Spend more, save more</p><div class="v4-ladder__steps">';
          tiers.forEach(function(t){ html += '<div class="v4-ladder__step"><b>' + t.pct + '% off</b><span>$' + t.min + '+</span></div>'; });
          html += '</div><p class="v4-ladder__note">Applied automatically in your bag. ' + (ss.note || '') + '</p>';
        }
        lad.innerHTML = html;
        form.insertAdjacentElement('afterend', lad);
        if (lad.classList.contains('v4-ladder--price')) {
          var priceEl = info.querySelector('[data-product-price]');
          var sel = info.querySelector('select[data-variant-select]');
          var cells = lad.querySelectorAll('.v4-ladder__step');
          var cents = function(){
            var o = sel && sel.options[sel.selectedIndex];
            var r = o && Number(o.getAttribute('data-price-raw'));
            if (r > 0) return r;
            var t = parseFloat(((priceEl && priceEl.textContent) || '').replace(/[^0-9.]/g, ''));
            return t > 0 ? Math.round(t * 100) : 0;
          };
          var paint = function(){
            var c = cents();
            [].forEach.call(cells, function(cell){
              var el = cell.querySelector('.v4-ladder__price');
              var pct = Number(cell.getAttribute('data-pct'));
              var txt = c > 0 ? '$' + ((c - Math.round(c * pct / 100)) / 100).toFixed(2) : '';
              if (el && el.textContent !== txt) el.textContent = txt;
            });
          };
          paint();
          document.addEventListener('change', function(e){ if (e.target && e.target.matches && e.target.matches('select[data-variant-select]')) setTimeout(paint, 0); }, true);
          document.addEventListener('click', function(e){ if (e.target.closest && e.target.closest('[data-db-tier],[data-rgp-tier]')) setTimeout(paint, 30); }, true);
          if (priceEl) { try { new MutationObserver(paint).observe(priceEl, { childList: true, characterData: true, subtree: true }); } catch (err) {} }
        }
      }
      var trust = info.querySelector('.product-info__micro-trust');
      if (trust && !trust.querySelector('.v4-pay')) {
        var pay = document.createElement('div');
        pay.className = 'v4-pay';
        ['Visa', 'Mastercard', 'Amex', 'Discover', 'Apple Pay', 'Google Pay', 'Shop Pay', 'PayPal'].forEach(function(n){ var s = document.createElement('span'); s.textContent = n; pay.appendChild(s); });
        trust.appendChild(pay);
      }
      info.appendChild(story);
    }
    if (cfg.comingSoon) {
      var soonBtn = document.querySelector('[data-add-to-cart-text]');
      var fixBtn = function(){ if (soonBtn && /sold out/i.test(soonBtn.textContent)) soonBtn.textContent = 'Coming soon'; };
      fixBtn();
      if (soonBtn) { try { new MutationObserver(fixBtn).observe(soonBtn, { childList: true, characterData: true, subtree: true }); } catch (e) {} }
      var name = cfg.productTitle || 'this routine';
      document.querySelectorAll('h2').forEach(function(h){
        if (/notify me when it returns/i.test(h.textContent)) {
          h.textContent = 'Tell me when it’s ready.';
          var sub = h.nextElementSibling;
          if (sub && /restock list/i.test(sub.textContent)) sub.textContent = 'Leave your email and we’ll let you know the moment ' + name + ' is ready to ship.';
        }
      });
      document.querySelectorAll('button').forEach(function(b){ if (/^join restock list$/i.test(b.textContent.trim())) b.textContent = 'Notify me'; });
    }
    var pb = document.querySelector('[data-v4-pause]');
    var anim = document.querySelector('[data-v4-anim]');
    if (pb && anim) {
      pb.addEventListener('click', function(){
        var on = anim.classList.toggle('is-paused');
        pb.setAttribute('aria-pressed', on ? 'true' : 'false');
        pb.setAttribute('aria-label', on ? 'Play animation' : 'Pause animation');
        pb.firstElementChild.innerHTML = on ? '&#9654;' : '&#10074;&#10074;';
      });
    }
  });
})();